<template>
	<div class="f-textarea inputfield inputfield--textarea" v-if="field">
		<textarea
		rows="3"
		class="st-input st-input--full st-input--textarea"

		v-validate="getFieldValidation(field)"
		v-model="value"
		:autocomplete="field.autocomplete"
		:disabled="systemdisable"
		:class="{'st-input--error': errors.has(field.name)}"
		:id="field.name"
		:name="field.name"
		:placeholder="(field.placeholder ? $t(field.placeholder) : '')"></textarea>
		<div class="error" v-show="errors.has(field.name)">
			{{ errors.first(field.name) }}
		</div>
	</div>
</template>

<script>

import fieldvalidation from '@/helpers/fieldvalidation.js';

export default {
	name: 'f-textarea',
	computed: {
		systemdisable(){
			let field = this.$store.getters.getEditFieldById(this.field.name);
			return field.disabled || this.$store.getters.loading || this.$store.getters.saveing;
		},
	  	value: {
		    get () {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		      	return field.value
		    },
		    set (value) {
		    	let field = this.$store.getters.getEditFieldById(this.field.name);
		    	field.value = value;
		    }
		}
	},
	props: {
		field: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},
	methods: {
		...fieldvalidation
	}
}
</script>



// WEBPACK FOOTER //
// src/components/form/f-textarea.vue